export default __webpack_public_path__ + "static/media/assessment-level-3.be38249b.svg";